export default "__VITE_ASSET__DRMyiVKT__"